import React from "react";

const SomethingWentWrongPage: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="text-center">
        <h1 className="text-2xl font-bold">Something went wrong</h1>
        <p className="text-gray-500">Please try again later.</p>
      </div>
    </div>
  );
};

export default SomethingWentWrongPage;
